define('v3/Common/Bindings/Menu.Binding',[
	'jquery',
	'knockout',
	'lodash',
	'env',
	'fastdom'
], function ($, ko, _, env, fastdom) {
	ko.bindingHandlers.menu = {
		init: function (element, valueAccessor) {
			valueAccessor();

			$(window).on('scroll', _.throttle(function () {
				fastdom.measure(function onScrollMenuMeasure () {
					var scrollTop = $(window).scrollTop();

					fastdom.mutate(function onScrollMenuMutate () {
						if (scrollTop > 20) {
							$(element).addClass('condensed');
						} else {
							$(element).removeClass('condensed');
						}
					});
				});
			}, 16.6));
		}
	};
});

